import { type RootState } from "features/Application/globaltypes/redux";

export const threatDefenceSmtpSettingsSelector = (state: RootState) => state.accounts.threatDefenceSmtpSettings;

export const threatDefenceSettingsSelector = (state: RootState) => state.accounts.threatDefenceSettings;
